var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BorderlessButton } from '@citrus/button';
import { HeaderBackButton } from '../Layout.styled';
import { Icon } from '@citrus/icon';
import { backIconButton as backIconButtonCitrus2022 } from '../../styles/citron';
import { backIcon, backIconButton } from '../../styles/legacy';
import { getAutomation } from '@citrus/runtime';
var BackButton = function (_a) {
    var automationId = _a.automationId, id = _a.id, lang = _a.lang, onBack = _a.onBack, isCitron = _a.isCitron;
    var getBackButtonId = function () { return (id ? { id: "".concat(id, "-back-button") } : {}); };
    if (isCitron) {
        return (React.createElement(BorderlessButton, __assign({ "aria-label": lang.ariaBack, onClick: onBack, size: "small", style: backIconButtonCitrus2022 }, getBackButtonId(), getAutomation(automationId, 'backbutton')),
            React.createElement(Icon, { "aria-label": "Back", bold: true, name: "back", size: "small" })));
    }
    return (React.createElement(HeaderBackButton, __assign({ "aria-label": lang.ariaBack, buttonType: "button", onClick: onBack, style: backIconButton }, getBackButtonId(), getAutomation(automationId, 'backbutton')),
        React.createElement(Icon, { name: "back", style: backIcon, title: "Back" })));
};
export default BackButton;
